import ko from 'knockout';
import _ from 'underscore';

export default class ViewModel {
  constructor({
    i18n,
    view,
    data,
    type,
    deps,
    readOnly,
    rejectedAd,
  }) {
    this.view = view;
    this.i18n = i18n;
    this.data = data;
    this.deps = deps;
    this.readOnly = readOnly;
    this.opportunityType = type;

    this.enableApply = ko.observable(true);
    this.finalUrl = ko.observable(rejectedAd.FinalUrl);
    this.enableResubmit = ko.computed(() =>
      !readOnly && (data.IsAppealable || this.finalUrl() !== rejectedAd.FinalUrl));

    this.displayUrl = ko.computed(() =>
      deps.adDisplayUrlService.getFinalUrlDomain(this.finalUrl()));

    this.showWarning = ko.observable(false);
    this.showEmptyTemplateWarning = ko.observable(false);

    this.selectIndex = ko.observable(0);

    this.exampleAds = ko.computed(() =>
      _.map(data.RejectedAds, (ad) => {
        const urlRegex = new RegExp('http:\/\/|https:\/\/|\{param', 'i'); // eslint-disable-line  no-useless-escape
        let destinationUrl = this.finalUrl();
        if (destinationUrl && destinationUrl.search(urlRegex) === -1) {
          destinationUrl = `http://${destinationUrl}`;
        }
        const convertDisplayUrl = deps.adDisplayUrlService.getExpandedTextAdDisplayUrl(
          destinationUrl,
          null,
          ad.Path1,
          ad.Path2
        );
        return {
          convertedTitle: _.compact([
            ad.Title1,
            ad.Title2,
            ad.Title3]).join(' | '),
          convertedText: deps.combineText(
            ad.Description1,
            ad.Description2
          ),
          convertDisplayUrl,
        };
      }));

    return this;
  }
}
